export enum Tab {
	Overview = 'overview',
	Markets = 'markets',
	Orders = 'orders',
	Leaderboard = 'leaderboard',
	Pools = 'pools',
	History = 'history',
	FAQ = 'faq',
}
